export enum GrowFollowersEditorStep {
  MESSAGE = 'message',
  PUBLISH = 'publish',
}

export enum LeadGenEditorStep {
  CONTEXT = 'context',
  MESSAGE = 'message',
  PUBLISH = 'publish',
}

export enum LeadQualEditorStep {
  CONFIG = 'config',
  EXIT_ACTION = 'exit_action',
  PUBLISH = 'publish',
}

export enum GoalTabs {
  SETUP = 'SETUP',
  STATS = 'STATS',
  PREVIEW = 'PREVIEW',
}

export enum GoalEditorMode {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
  SAVING_BLOCKED = 'SAVING_BLOCKED',
  READ = 'READ',
}

export interface StepState<
  T extends GrowFollowersEditorStep | LeadGenEditorStep | LeadQualEditorStep,
> {
  current: T
  completed: Record<T, boolean>
}

export type SubmitResult<T> = { isValid: true; data: T } | { isValid: false }

export interface SubmitRef<T> {
  submit: () => Promise<SubmitResult<T>>
}
